/* eslint-disable key-spacing */
import { hsl } from '../../../utils/svgs'

export default {
    fill: {
        catherineGlasses: hsl(358, 40, 39),
    },
}
